<mh-spinner-classic [hidden]="!waiting"></mh-spinner-classic>

<ng-container *ngIf="!waiting">
  <widgets-table-periods
    [dataSource]="dataSource"
    [headerTable]="headerKeys"
    [chain]="chainActives"
    [totals]="totals"
    [tooltipHeaders]="tooltipHeaders"
    [prefixTranslate]="'inter-chain.collect.table'"
  ></widgets-table-periods>
</ng-container>
